<template lang="pug">
div.row
    div.col-sm-12.voided-box.text-center(v-if="isVoided")
        small.block {{ receipt.void_remarks }}
        small
            | Voided by 
            span._500 {{ voider.name }} 
            | on {{ receiptDateFormat(receipt.voided_at) }}

</template>

<script>
import receiptMixin from '../../mixins/receipt';
import { mapGetters, mapActions } from 'vuex';

export default {
    mixins: [receiptMixin],

    computed: {
        ...mapGetters('transaction', ['isVoided', 'receipt', 'voider']),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/receipt/footer.vue